import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
    mapContainer: {
        display: 'flex',
        justifyContent: 'center',
        '& .map': {
            minHeight: '350px',
            width: '100%',
        },
    },
}))

export default useStyles
